import { MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';
import Alert from 'directives/dashboard/ui-alert/-RFC.ui-alert-logic';


const _directiveDependencies = [];
const _controllerDependencies = ['$rootScope', '$scope', '$state',
    'Util', 'ProfileImageRestService', 'UserRestService'];

let _$scope;
let _$state;
let _Util;
let _UserRestService;
let _MeRepository;

class ProfileImageController {

    constructor(
        $rootScope, $scope, $state, Util,
        ProfileImageRestService, UserRestService,
    ) {

        this.ProfileImageRestService = ProfileImageRestService;

        _UserRestService = UserRestService;
        _MeRepository = MeRepository;
        _Util = Util;
        _$scope = $scope;
        _$state = $state;

        _$scope.user = MeRepository.getMyUser();
        _$scope.imageFile = {};

        // MeRepository Observable
        const meRepositoryObservable = MeRepository.getObservable();
        const onNextMeRepository = () => {

            // get user from MeRepository
            _$scope.user = MeRepository.getMyUser();

        };

        // trigger onNextMeRepository() on MeRepository update
        this.meRepositorySubscriber = meRepositoryObservable.subscribe(
            onNextMeRepository,
            () => { },
            () => { },
        );

        // validate image size: maximum 2 MB
        const isImageSizeValid = size => size < (2000 * 1000);

        // validate image formats: gif, jpg, png, jpeg
        const isImageTypeValid = type => !!type.match(/(?:gif|jpg|png|jpeg)$/);

        const inputFileElement = angular.element('#inputFile');

        /* on change event;
            here we are using $scope.$apply because angular
            does not have direct binding for "on change event" */
        inputFileElement.bind('change', (event) => {

            const fileExists = _Util.deepFind(event, 'currentTarget.files.length');

            if (fileExists) {

                const file = inputFileElement[0].files[0];

                if (isImageSizeValid(file.size) && isImageTypeValid(file.type)) {

                    /* 1. set on $rootScope the @event param data.
                        2. the @event data will be used by "ui-cropper" directive */
                    $rootScope.imageFileEvent = event;

                    // remove error message if the image file is valid
                    _$scope.$apply(() => {

                        delete _$scope.imageFile.error;

                    });

                    // open image cropping modal
                    _$state.go('root.dashboard.my-account.ltb', {
                        ltb: 'crop-image',
                    });

                }

                // error cases
                if (!isImageSizeValid(file.size)) {

                    _$scope.$apply(() => {

                        _$scope.imageFile.error = 'tooLarge';

                    });

                }

                if (!isImageTypeValid(file.type)) {

                    _$scope.$apply(() => {

                        _$scope.imageFile.error = 'wrongFormat';

                    });

                }

            } else {

                // remove error message if the user closes the browsing files window
                _$scope.$apply(() => {

                    delete _$scope.imageFile.error;

                });

            }

        });

    }

    removeImage(action) {

        Mixpanel.send('ConnectWeb Remove Photo Click');

        // this call removes the image from server
        this.ProfileImageRestService
            .remove(action)
            .then(() => {

                const userImagePayload = {
                    data: {
                        attributes: {
                            profile_image_medium: '',
                        },
                        type: 'users',
                        id: _$scope.user.id,
                    },
                };

                // update user attribute "profile_image_medium" with an empty string
                _UserRestService.update(_$scope.user.id, userImagePayload).then((response) => {

                    _MeRepository.update(response.data.data);
                    _Util.updateLastLoginObjectInLocalStorage(response.data.data);
                    Alert.success('cw.profile.picture.alerts.remove_success');

                }).then(null, () => {

                    Alert.error('cw.profile.picture.alerts.remove_error');

                });

            })
            .then(null, () => {

                Alert.error('cw.profile.picture.alerts.remove_error');

            });

    }

    onOpenFileBrowser() {

        Mixpanel.send('ConnectWeb Upload Photo Click');

        // reset input value every time we click it in order to emit "on change" event
        angular.element('#inputFile')[0].value = '';

    }

}

class ProfileImageDirective {

    constructor() {

        this.template = require('./profile-image.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push((
            $rootScope, $scope, $state,
            Util, ProfileImageRestService, UserRestService,
        ) =>
            new ProfileImageController(
                $rootScope, $scope, $state,
                Util, ProfileImageRestService, UserRestService,
            ));
        this.controller = _controllerDependencies;
        this.controllerAs = 'profileImageCtrl';

    }

}

_directiveDependencies.push(() => new ProfileImageDirective());

angular.module('directives')
    .directive('profileImage', _directiveDependencies);




// WEBPACK FOOTER //
// ./scripts/directives/dashboard/my-account/profile/profile-image/profile-image.js